import Dashboard from './home';
import Profile from './profile';
import ChangePassword from './profile/ChangePassword';
import Children from './children';
import ChildDetails from './children/Details';
import ChildHistory from './children/History';
import ChildMakeupSummary from './children/MakeupSummary';
import ChildMedicalInformation from './children/MedicalInformation';
import Payments from './payments';
import PaymentDetails from './payments/Details';
import Enrolments from './enrolments';
import EnrolmentDetails from './enrolments/Details';
import WorkshopEnrolments from './workshopEnrolments';
import WorkshopEnrolmentDetails from './workshopEnrolments/Details';
import IndividualConsultations from './individualConsultations';
import IndividualConsultationDetails from './individualConsultations/Details';
import IndividualConsultationFormDetails from './individualConsultations/FormDetails';
import IndividualProgramDocuments from './individualConsultations/IndividualProgramDocuments';
import IndividualConsultationForms from './individualConsultations/FormsDashboard';
import Booking from './booking';
import BookingProcess from './booking/Process';
import BookingComplete from './booking/Complete';
import BookingCancelled from './booking/Cancelled';
import WorkshopBooking from './booking/Workshop';
import NeurologicalInfo from './info/Neurological';
import NeurologicalInfoDetails from './info/NeurologicalDetails';
import Instructions from './info/Instructions';
import TermsAndConditions from './info/TermsAndConditions';
import SelfAssessments from './selfAssessments';
import SelfAssessmentDetails from './selfAssessments/Details';

export const ROUTES = [
	{
		path: '/',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_Dashboard',
		mainContent: Dashboard
	},
	{
		path: '/profile',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_Profile',
		mainContent: Profile
	},
	{
		path: '/children',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_Children',
		mainContent: Children
	},
	{
		path: '/children/:id/:tab?',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_EditChild',
		mainContent: ChildDetails
	},
	//{
	//	path: '/children/:id/history',
	//	pageTitleResourceKey: 'FO_PageTitle_Parent_ChildHistory',
	//	mainContent: ChildHistory
	//},
	//{
	//	path: '/children/:id/makeupSummary',
	//	pageTitleResourceKey: 'FO_PageTitle_Parent_MakeupSummary',
	//	mainContent: ChildMakeupSummary
	//},
	//{
	//	path: '/children/:id/medicalInformation',
	//	pageTitleResourceKey: 'FO_PageTitle_Parent_MedicalInformation',
	//	mainContent: ChildMedicalInformation
	//},
	{
		path: '/booking/process/:id?',
		pageTitleResourceKey: '',
		mainContent: BookingProcess
	},
	{
		path: '/individual-consultation/booking/process/:id?',
		pageTitleResourceKey: '',
		mainContent: BookingProcess
	},
	{
		path: '/workshop/booking/:centerId/:workshopId/process/:id?',
		pageTitleResourceKey: '',
		mainContent: BookingProcess
	},
	{
		path: '/booking/complete/:id?',
		mainContent: BookingComplete
	},
	{
		path: '/individual-consultation/booking/complete/:id?',
		mainContent: BookingComplete
	},
	{
		path: '/workshop/booking/:centerId/:workshopId/complete/:id?',
		mainContent: BookingComplete
	},
	{
		path: '/booking/cancelled/:id?',
		mainContent: BookingCancelled
	},
	{
		path: '/individual-consultation/booking/cancelled/:id?',
		mainContent: BookingCancelled
	},
	{
		path: '/workshop/booking/:centerId/:workshopId/cancelled/:id?',
		mainContent: BookingCancelled
	},
	{
		path: '/booking/:step/:id?',
		exact: true,
		//	pageTitleResourceKey: 'FO_PageTitle_Parent_Classes',
		mainContent: Booking
	},
	{
		path: '/individual-consultation/booking/:step/:id?',
		exact: true,
		//	pageTitleResourceKey: 'FO_PageTitle_Parent_BookIndividualConsultation',
		mainContent: Booking
	},
	{
		path: '/workshop/booking/:centerId/:workshopId/:step/:id?',
		exact: true,
		mainContent: WorkshopBooking
	},
	{
		path: '/payment-history',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_PaymentHistory',
		mainContent: Payments
	},
	{
		path: '/payment-history/:id/:type',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_PaymentDetails',
		mainContent: PaymentDetails
	},
	{
		path: '/enrolments',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_Enrolments',
		mainContent: Enrolments
	},
	{
		path: '/enrolments/:id',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_EnrolmentDetails',
		mainContent: EnrolmentDetails
	},
	{
		path: '/workshop-enrolments',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_WorkshopEnrolments',
		mainContent: WorkshopEnrolments,
		hasAccess: (parent, centers, franchisor) => franchisor.enableWorkshops
	},
	{
		path: '/workshop-enrolments/:id',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_WorkshopEnrolmentDetails',
		mainContent: WorkshopEnrolmentDetails
	},
	{
		path: '/neurological-info',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_NeurologicalInfo',
		mainContent: NeurologicalInfo
	},
	{
		path: '/neurological-info/:slug',
		pageTitleResourceKey: 'FO_PageTitle_Parent_NeurologicalInfo',
		mainContent: NeurologicalInfoDetails
	},
	{
		path: '/individual-consultation/documents',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_IndividualConsultationTeacherDocuments',
		mainContent: IndividualProgramDocuments
	},
	{
		path: '/individual-consultation/results',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_IndividualConsultationResults',
		mainContent: IndividualConsultationForms
	},
	{
		path: '/individual-consultation',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_IndividualConsultation',
		mainContent: IndividualConsultations
	},
	{
		path: '/individual-consultation/:id',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_IndividualConsultationDetails',
		mainContent: IndividualConsultationDetails
	},
	{
		path: '/individual-consultation/:id/forms/:formId',
		exact: true,
		pageTitleResourceKey: '', // form name to be used as a title //'FO_PageTitle_Parent_IndividualConsultationFormDetails',
		mainContent: IndividualConsultationFormDetails
	},
	{
		path: '/info',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_Info',
		mainContent: Instructions
	},
	{
		path: '/termsAndConditions',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_TermsAndConditions',
		mainContent: TermsAndConditions
	},
	{
		path: '/change-password',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_ChangePassword',
		mainContent: ChangePassword
	},
	{
		path: '/self-assessments/:childId?',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_SelfAssessments',
		mainContent: SelfAssessments
	},
	{
		path: '/self-assessments/:childId/:formId',
		exact: true,
		pageTitleResourceKey: 'FO_PageTitle_Parent_SelfAssessments',
		mainContent: SelfAssessmentDetails
	}
];

export const MAIN_MENU = [
	{
		path: '/',
		textResourceKey: 'FO_MainMenu_Parent_Dashboard',
		hasAccess: parent => true
	},
	{
		path: '/booking/child?reset=true',
		textResourceKey: 'FO_MainMenu_Parent_Classes',
		hasAccess: parent => parent.children.length > 0
	},
	{
		path: '/booking/child?add=true&reset=true',
		textResourceKey: 'FO_MainMenu_Parent_Classes',
		hasAccess: parent => parent.children.length === 0
	},
	{
		path: '/public/centers?referrer=workshops',
		textResourceKey: 'FO_MainMenu_Parent_Workshops',
		hasAccess: (parent, centers, franchisor) => franchisor.enableWorkshops && centers && centers.some(c => c.isWorkshops)
	},
	{
		textResourceKey: 'FO_MainMenu_Parent_IndividualConsultation',
		hasAccess: (parent, centers) => centers && centers.some(c => c.isIndividualConsultation),
		submenus: [
			{
				path: '/individual-consultation/booking/child?reset=true',
				textResourceKey: 'FO_MainMenu_Parent_IndividualConsultation_Book',
				hasAccess: () => true
			},
			{
				path: '/individual-consultation',
				textResourceKey: 'FO_MainMenu_Parent_IndividualConsultation_List',
				hasAccess: () => true
			},
			{
				path: '/individual-consultation/documents',
				textResourceKey: 'FO_MainMenu_Parent_IndividualConsultation_Documents',
				hasAccess: () => true
			},
			{
				path: '/individual-consultation/results',
				textResourceKey: 'FO_MainMenu_Parent_IndividualConsultation_Results',
				hasAccess: (parent, centers, franchisor) => franchisor.customUIComponents && franchisor.customUIComponents.childFormsDashboard
			}
		]
	},
	{
		textResourceKey: 'FO_MainMenu_ParentInfo',
		hasAccess: (parent, centers, franchisor) => !franchisor.hideParentInfoFrontOfficeMenu,
		submenus: [
			{
				path: '/neurological-info',
				textResourceKey: 'FO_MainMenu_Parent_NeurologicalInfo',
				hasAccess: parent => parent.hasPaidAccess
			},
			{
				path: '/info',
				textResourceKey: 'FO_MainMenu_Parent_Info',
				hasAccess: parent => true
			},
			{
				path: '/termsAndConditions',
				textResourceKey: 'FO_MainMenu_Parent_TermsAndConditions',
				hasAccess: parent => true
			}
		]
	},
	{
		path: '/self-assessments',
		textResourceKey: 'FO_MainMenu_Parent_SelfAssessments',
		hasAccess: (parent, centers, franchisor) => franchisor.enableSelfAssessments
	},
	{
		textResourceKey: 'FO_MainMenu_Profile',
		hasAccess: parent => true,
		submenus: [
			{
				path: '/payment-history',
				textResourceKey: 'FO_MainMenu_Parent_PaymentHistory',
				hasAccess: parent => parent.children.length > 0
			},
			{
				path: '/enrolments',
				textResourceKey: 'FO_MainMenu_Parent_Enrolments',
				hasAccess: parent => parent.children.length > 0
			},
			{
				path: '/workshop-enrolments',
				textResourceKey: 'FO_MainMenu_Parent_WorkshopEnrolments',
				hasAccess: (parent, centers, franchisor) => franchisor.enableWorkshops && parent.children.length > 0
			},
			{
				path: '/children',
				textResourceKey: 'FO_MainMenu_Parent_Children',
				hasAccess: parent => true
			},
			{
				path: '/profile',
				textResourceKey: 'FO_MainMenu_Parent_Profile',
				hasAccess: parent => true
			},
			{
				path: '/change-password',
				textResourceKey: 'FO_MainMenu_Parent_ChangePassword',
				hasAccess: parent => true
			}
		],
		isProfile: true
	}
];